import type { FaireProductEntity } from "../../entity_types/product";

export const p_53myskjssy: FaireProductEntity = {
  token: "p_53myskjssy",
  type: "product",
  name: "Rosemary & Mint Original Plastic Free Deodorant",
  brandToken: "b_axtc527c9j",
  brandName: "Humble Brands, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/b30e7171f3a6bb318f9655d7aa71914ff4fe326618f165a1efbdfd269b575af6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5b21f26011a261319ce178fa0dfcbee1a33db50647e64e6cb2c2eb6654f2ae6.jpeg",
    "https://cdn.faire.com/fastly/8951ba89bad34e665e1e41bba54acf1937d88d4dd1325ba69500d53269735fae.jpeg",
    "https://cdn.faire.com/fastly/930113f1079bb6cd506216750383dac9efe148a5aa7a80ec27ffbb4ffab62ffe.jpeg",
    "https://cdn.faire.com/fastly/d379b98365358c24d5f1549df72c5281462264a8df7599e089a8e437d8b08975.jpeg",
    "https://cdn.faire.com/fastly/ad832e2dfc7e27a843cb4bdd783aaa70d4aa885c7b05cf1e0014a384190bda0a.jpeg",
    "https://cdn.faire.com/fastly/822c0640148b461992ef8fef338bbc160927d3099142ae108455deecbef025b5.jpeg",
  ],
  priceDollars: 8.99,
  description:
    "Scent Note: Woody, Citrus-like Notes with Sweet Spearmint\n\nProduct Description: Made with simple, highly effective ingredients (MCT oil, non-GMO corn starch, beeswax, baking soda and botanically-based scents). Humble Brands Deodorant is formulated to absorb and neutralize body odor and has no aluminum, alcohol, dyes, parabens, sulfates or artificial fragrance. From the paperboard packaging to the ink and lining, Humble’s plastic-free deodorant will biodegrade in 2-5 months and is recyclable. Certified Cruelty-Free by Leaping Bunny and a 1% for the Planet product that gives back with every purchase. \n\nSize: 2.65 oz. / 75g",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:09.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
